import { render, staticRenderFns } from "./RestaurantEdit.vue?vue&type=template&id=14296276&scoped=true"
import script from "./RestaurantEdit.vue?vue&type=script&lang=js"
export * from "./RestaurantEdit.vue?vue&type=script&lang=js"
import style0 from "./RestaurantEdit.vue?vue&type=style&index=0&id=14296276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14296276",
  null
  
)

export default component.exports